function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-kunde375"
}, /*#__PURE__*/React.createElement("rect", {
  width: 375,
  height: 250
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "kunde375",
  clipPath: "url(#clip-kunde375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3708",
  "data-name": "Gruppe 3708"
}, /*#__PURE__*/React.createElement("g", {
  id: "kunde375-2",
  "data-name": "kunde375",
  transform: "translate(-46 -16.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_349",
  cx: 93.6,
  cy: 93.6,
  r: 93.6,
  transform: "translate(139.9 47.9)",
  fill: "#002b47"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_350",
  cx: 9.3,
  cy: 9.3,
  r: 9.3,
  transform: "translate(224.2 132.2)",
  fill: "#17a8e6"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_760",
  "data-name": "Rechteck 760",
  width: 375,
  height: 250,
  fill: "none"
})));

function SvgKunde375(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 250,
    viewBox: "0 0 375 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKunde375);
export default __webpack_public_path__ + "static/media/kunde375.1d0f22db.svg";
export { ForwardRef as ReactComponent };